import { Trans, useTranslation } from 'next-i18next';
import Link from 'next-translate-routes/link';
import type { FC } from 'react';
import React from 'react';

import type { DepositGuideStep } from '@/components/DepositOpeningGuide/utils';
import { cn } from '@/utils';

interface DepositOpeningGuideProps {
  steps: DepositGuideStep[];
  title?: string;
  className?: string;
  containerClassName?: string;
}

export const DepositOpeningGuide: FC<DepositOpeningGuideProps> = ({
  className,
  steps,
  title,
  containerClassName,
}) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      {title && <p className="h5 mb-6">{title}</p>}
      <div
        className={cn(
          'grid grid-cols-1 gap-[44px] sm:grid-cols-4',
          containerClassName,
        )}
      >
        {steps.map((step, index) => (
          <div
            key={index}
            className="relative flex gap-4 sm:flex-col sm:gap-6 sm:overflow-hidden"
          >
            {index !== steps.length - 1 && (
              <span className="absolute left-[14px] top-11 z-[-1] block h-[64%] w-[2px] bg-blue-50 sm:left-0 sm:top-[20px] sm:ml-14 sm:h-[2px] sm:w-full" />
            )}
            <span className="z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-100 text-[12px] font-semibold text-blue-500 sm:h-10 sm:w-10 sm:text-[15px]">
              {index + 1}
            </span>
            <div className="pr-4">
              {step.title && (
                <p className="body3-bold text-blue-900">{t(step.title)}</p>
              )}
              <p className="body3 mt-1 text-grey-600">
                <Trans
                  i18nKey={t(step.description)}
                  t={t}
                  components={{
                    pickTheBankUrl: <Link href="/" className="text-blue-500" />,
                  }}
                />
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
